import { isFlowAction, type ActionModel } from '~/jet/models';
import { isCompoundFlowAction, isExternalAction } from '~/actions/click-action';

export function extractActionHref(action: ActionModel): string | null {
    if (isFlowAction(action)) {
        return (action?.destination as any)?.contentDescriptor?.url;
    } else if (isCompoundFlowAction(action)) {
        const flowAction = action?.subactions?.find((subaction) =>
            isFlowAction(subaction),
        );
        return extractActionHref(flowAction);
    } else if (isExternalAction(action)) {
        return action?.url;
    }
    return null;
}
